/**
 * Panel definitions for flex/fcr segment
 * Add your fcr-related panels here based on backend dataset configs
 */
import { applyCountryFilterToPanels } from './countryContext';

const basePanels = [
  // First row: yesterday / today / tomorrow (3 panels, 8 cols each)
  {
    id: 'fcr-prices-yesterday',
    type: 'datasetChart',
    datasetId: 'entsoe-fcr-prices',
    visualizationId: 'fcr-prices-fcr-yesterday',
    gridPos: { x: 0, y: 0, w: 8, h: 10 },
  },
  {
    id: 'fcr-prices-today',
    type: 'datasetChart',
    datasetId: 'entsoe-fcr-prices',
    visualizationId: 'fcr-prices-fcr-today',
    gridPos: { x: 8, y: 0, w: 8, h: 10 },
  },
  {
    id: 'fcr-prices-tomorrow',
    type: 'datasetChart',
    datasetId: 'entsoe-fcr-prices',
    visualizationId: 'fcr-prices-fcr-tomorrow',
    gridPos: { x: 16, y: 0, w: 8, h: 10 },
  },

  // Second row: 2 panels side-by-side (12 cols each)
  {
    id: 'today-fcr-prices',
    type: 'datasetChart',
    datasetId: 'entsoe-fcr-prices',
    visualizationId: 'fcr-prices-fcr-today',
    gridPos: { x: 0, y: 10, w: 12, h: 12 },
  },
  {
    id: 'this-week-fcr-prices',
    type: 'datasetChart',
    datasetId: 'entsoe-fcr-prices',
    visualizationId: 'fcr-prices-fcr-last-7d',
    gridPos: { x: 12, y: 10, w: 12, h: 12 },
  },
  // Third row: 2 panels side-by-side (12 cols each)
  {
    id: 'fcr-prices-by-month',
    type: 'datasetChart',
    datasetId: 'entsoe-fcr-prices',
    visualizationId: 'fcr-prices-fcr-by-month',
    gridPos: { x: 0, y: 22, w: 12, h: 15 },
  },
  {
    id: 'fcr-prices-by-year',
    type: 'datasetChart',
    datasetId: 'entsoe-fcr-prices',
    visualizationId: 'fcr-prices-fcr-by-year',
    gridPos: { x: 12, y: 22, w: 12, h: 15 },
  },

  // FCR Matching Volumes - Row 1 (3 panels)
  {
    id: 'fcr-matching-volumes-p1',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-volumes-p1',
    gridPos: { x: 0, y: 37, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-volumes-p2',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-volumes-p2',
    gridPos: { x: 8, y: 37, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-volumes-p3',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-volumes-p3',
    gridPos: { x: 16, y: 37, w: 8, h: 12 },
  },

  // FCR Matching Volumes - Row 2 (3 panels)
  {
    id: 'fcr-matching-volumes-p4',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-volumes-p4',
    gridPos: { x: 0, y: 49, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-volumes-p5',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-volumes-p5',
    gridPos: { x: 8, y: 49, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-volumes-p6',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-volumes-p6',
    gridPos: { x: 16, y: 49, w: 8, h: 12 },
  },

  // FCR Matching Prices - Row 3 (3 panels)
  {
    id: 'fcr-matching-prices-p1',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-prices-p1',
    gridPos: { x: 0, y: 61, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-prices-p2',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-prices-p2',
    gridPos: { x: 8, y: 61, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-prices-p3',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-prices-p3',
    gridPos: { x: 16, y: 61, w: 8, h: 12 },
  },

  // FCR Matching Prices - Row 4 (3 panels)
  {
    id: 'fcr-matching-prices-p4',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-prices-p4',
    gridPos: { x: 0, y: 73, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-prices-p5',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-prices-p5',
    gridPos: { x: 8, y: 73, w: 8, h: 12 },
  },
  {
    id: 'fcr-matching-prices-p6',
    type: 'datasetChart',
    datasetId: 'regelleistung-fcr-matching',
    visualizationId: 'regelleistung-fcr-matching-prices-p6',
    gridPos: { x: 16, y: 73, w: 8, h: 12 },
  },
];

export const flexFcrPanels = ({ country } = {}) => applyCountryFilterToPanels(basePanels, country);

export const flexFcrSyncGroups = [
  {
    id: 'fcr-prices-row',
    global: false,
    ids: ['fcr-prices-yesterday', 'fcr-prices-today', 'fcr-prices-tomorrow'],
    syncAxes: { y: true },
  },
  {
    id: 'fcr-matching-filters-sync',
    global: false,
    ids: [
      'fcr-matching-volumes-p1',
      'fcr-matching-volumes-p2',
      'fcr-matching-volumes-p3',
      'fcr-matching-volumes-p4',
      'fcr-matching-volumes-p5',
      'fcr-matching-volumes-p6',
      'fcr-matching-prices-p1',
      'fcr-matching-prices-p2',
      'fcr-matching-prices-p3',
      'fcr-matching-prices-p4',
      'fcr-matching-prices-p5',
      'fcr-matching-prices-p6',
    ],
    syncFilters: ['date_range', 'granularity'],
  },
  {
    id: 'fcr-matching-volumes-sync',
    global: false,
    ids: [
      'fcr-matching-volumes-p1',
      'fcr-matching-volumes-p2',
      'fcr-matching-volumes-p3',
      'fcr-matching-volumes-p4',
      'fcr-matching-volumes-p5',
      'fcr-matching-volumes-p6',
    ],
    syncAxes: {
      y: true,
    },
  },
  {
    id: 'fcr-matching-prices-sync',
    global: false,
    ids: [
      'fcr-matching-prices-p1',
      'fcr-matching-prices-p2',
      'fcr-matching-prices-p3',
      'fcr-matching-prices-p4',
      'fcr-matching-prices-p5',
      'fcr-matching-prices-p6',
    ],
    syncAxes: {
      y: true,
    },
  },
];
